import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import 'tslib';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import '../Icon/ImgIcon.esm.js';
import '../Icon/FaIcon.esm.js';
import { LoadingIcon } from '../Icon/SemanticIcons.esm.js';
import { Body } from '../Typography/Body.esm.js';
import '../Tooltip/Tooltip.esm.js';
import { Title } from '../Typography/Title.esm.js';

var appearanceClasses = {
    primary: "tw-border-b tw-border-gray-300 dark:tw-border-gray-700",
    striped: "tw-border-b tw-border-gray-300 tw-bg-gray-100 dark:tw-border-gray-700 dark:tw-bg-gray-1000",
    clear: "tw-border-b-0"
};
/**
 * A styled container to be used within a Card.
 */
function CardHeader(_a) {
    var addClassName = _a.addClassName, actions = _a.actions, _b = _a.appearance, appearance = _b === void 0 ? "primary" : _b, dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId, userIcon = _a.icon, iconLeft = _a.iconLeft, _c = _a.isBackgroundFetching, isBackgroundFetching = _c === void 0 ? false : _c, _d = _a.level, level = _d === void 0 ? 3 : _d, title = _a.title, subTitle = _a.subTitle;
    var icon = userIcon || iconLeft;
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId ||
            "card-header-".concat(typeof title === "string" && testIdGen(title)), className: classNames("tw-box-border tw-border-solid tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-flex-0 tw-rounded-t tw-px-4 tw-py-2", appearanceClasses[appearance], addClassName) },
        React.createElement("div", { className: "tw-flex tw-justify-between tw-items-center" },
            React.createElement("div", { className: "tw-flex tw-space-x-1 tw-items-center" },
                icon && React.createElement("div", { className: "tw-self-start tw-mt-1.5" }, icon),
                React.createElement("div", { className: "tw-flex tw-flex-col ".concat(icon ? "tw-pl-2" : "") },
                    React.createElement(Title, { "data-testid": "card-title", level: level, size: "xxs" }, title),
                    subTitle && (React.createElement(Body, { appearance: "secondary", "data-testid": "card-subtitle", size: "sm" }, subTitle)))),
            (actions || isBackgroundFetching) && (React.createElement("div", { className: "tw-flex tw-space-x-2 tw-items-center" },
                isBackgroundFetching && React.createElement(LoadingIcon, null),
                actions)))));
}

export { CardHeader };
//# sourceMappingURL=CardHeader.esm.js.map
